import { Modal, ModalProps } from 'modules/modal/ui/Modal'
import { Title } from 'shared/ui/common/Title'
import { Button } from 'shared/ui/controls/Button'
import { useLocalStorage } from 'shared/hooks/useLocalStorage'
import { LS_KEY_SKIP_DISCLAIMER } from './constants'
import { openWindow } from 'shared/utils/openWindow'
import { useFirebase } from 'modules/analytics/firebase'
import {
  DISCLAIMER_CLOSE_EVENT,
  DISCLAIMER_TOS_OPEN_EVENT,
} from 'modules/analytics/events'

import s from './DisclaimerModal.module.scss'

export const DisclaimerModal = (props: ModalProps) => {
  const [, setDisclaimerFlag] = useLocalStorage(LS_KEY_SKIP_DISCLAIMER, '0')
  const { onClose } = props
  const { trackEvent } = useFirebase()

  const handleAgreeClick = () => {
    setDisclaimerFlag('1')
    trackEvent(DISCLAIMER_CLOSE_EVENT, { agree: 'true' })
    onClose()
  }

  const handleClose = () => {
    trackEvent(DISCLAIMER_CLOSE_EVENT, { agree: 'false' })
    openWindow('/', '_self')
  }

  const trackTosOpen = () => trackEvent(DISCLAIMER_TOS_OPEN_EVENT)

  return (
    <Modal
      {...props}
      width={700}
      withCloseOnClickOutside={false}
      className={s.root}
      onClose={handleClose}
    >
      <Title isCentered className={s.title}>
        By using RociFi App <br /> you agree to
      </Title>
      <ol>
        <li>When using RociFi I understand that:</li>
        <ul>
          <li>
            The RociFi Protocol (“The Protocol”) is risky and highly
            experimental. The Protocol is the early stage software and may have
            undiagnosed bugs.
          </li>
          <li>
            Funds may be lost through a security breach, malfunction, attack or
            code exploit.
          </li>
          <li>
            This app is operated by RociFi Labs PTE LTD (“The Protocol
            Operators”). The Protocol operators do not give investment advice,
            endorsement, analysis or recommendations with respect to any
            cryptocurrencies, digital assets, tokens or securities or provide
            any financial, tax, legal advice or consultancy services of any
            kind. We are not your broker, intermediary, agent, or advisor and
            have no fiduciary relationship or obligation to you in connection
            with any trades or other decisions or activities affected by you
            using this app.
          </li>
          <li>
            This app has not been approved by any regulator. This app is for
            “professional investors”, “accredited investors” or “sophisticated
            investors” only and not for retail use. We encourage you to consult
            your professional advisers in respect of any decisions or activities
            made on the app.
          </li>
          <li>
            Investing in cryptocurrencies is highly risky and may lead to a
            total loss of investment. You must have sufficient understanding of
            cryptographic tokens and blockchain technology to appreciate the
            risks involved in investing in cryptocurrencies.
          </li>
          <li>
            Protocol operators have no custody over my funds, ability or duty to
            transact on my behalf or power to reverse my transactions neither
            provide any warranty with respect to my tokens.
          </li>
          <li>
            I will not be able to recoup gas fees paid to the network to use The
            Protocol.
          </li>
        </ul>
        <li>To protect the RociFi community, I will not:</li>
        <ul>
          <li>Act with malicious intent when utilizing The Protocol.</li>
          <li>Take any action that may harm the Protocol, users, or funds.</li>
        </ul>
        <li>
          I have read, understood and hereby agree to be legally as a 'User' and
          the{' '}
          <a href="/terms-of-service" target="_blank" onClick={trackTosOpen}>
            Terms of Service
          </a>
          , including all future amendments thereto. Such agreement is
          irrevocable and will apply to all my uses of the Protocol without me
          providing confirmation in each specific instance.
        </li>
        <li>
          By agreeing to the{' '}
          <a href="/terms-of-service" target="_blank" onClick={trackTosOpen}>
            Terms of Service
          </a>
          , I agree that in case of non-repayment of the unsecured debt on time
          RociFi has the right to publicly share digital identity of the debtor
          (f.e. Borrower’s Twitter handle) and debt amount via own social media
          and social media of its community until the total debt amount is
          repaid.
        </li>
      </ol>
      <Button
        fashion="default"
        onClick={handleAgreeClick}
        testId="i-agree-button"
      >
        I agree
      </Button>
    </Modal>
  )
}
